export default from './BookingPayment';



// WEBPACK FOOTER //
// ./src/containers/BookingPayment/index.js